import { motion, MotionValue, useTransform } from 'framer-motion';

interface ProgressBarProps {
  progress?: number | MotionValue<number>;
  currentStep?: number;
  totalSteps?: number;
  className?: string;
  isChunky?: boolean;
}

export const ProgressBar = (props: ProgressBarProps) => {
  const variantTrackStyle = props.isChunky ? "h-[13px]" : "h-[6px]";
  const variantProgressStyle = props.isChunky ? "bg-gradient-to-r from-osYellow-3 to-pink-mascotte" : "bg-osBlack";

  // Calculate progress value
  const getProgressValue = (): number | MotionValue<number> => {
    // If currentStep is provided, calculate progress from steps
    if (props.currentStep !== undefined) {
      const totalSteps = props.totalSteps || 100;
      const calculatedProgress = Math.min(Math.max((props.currentStep / totalSteps) * 100, 0), 100);
      return calculatedProgress;
    }

    // Fall back to direct progress prop
    if (props.progress !== undefined) {
      return props.progress;
    }

    // Default to 0 if nothing is provided
    return 0;
  };

  const progressValue = getProgressValue();

  const widthValue = typeof progressValue === 'number'
    ? `${progressValue}%`
    : useTransform(progressValue as MotionValue<number>, (value) => `${value}%`);

  return (
    <div className={`w-full ${variantTrackStyle} bg-osGrey-4 rounded-full overflow-hidden ${props.className}`}>
      <motion.div
        className={`h-full ${variantProgressStyle} rounded-full`}
        style={{ width: widthValue }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      />
    </div>
  );
};

